

/// <reference path="../../../app.definition.ts" />

import angular from 'angular';

export class AutoFocus implements angular.IDirective {
    restrict = 'A';
    link = function (scope, element, attrs) {
        element[0].focus();
    };
    constructor() { }

    static factory(): angular.IDirectiveFactory {
        const directive = () => new AutoFocus();

        return directive;
    }
}

angular.module('eCareVault.common.directives')
    .directive('autoFocus', AutoFocus.factory());
